import React from 'react';
import { UiIconMaterial } from '@open-stack/ui';
import styled from 'styled-components';

const Wrapper = styled.div`
    .UiImage {
        border-radius: 30px;
    }

    .image-container {
        width: 300px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);

        img {
            max-width: 100%;
        }
    }

    .ov {
        position: absolute;
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 1;

        &.left,
        &.right {
            height: 100%;
            top: 0;
        }

        &.left {
            width: 80px;
            left: 0;
        }

        &.right {
            width: 80px;
            right: 0;
        }

        &.top,
        &.bottom {
            left: 80px;
            width: calc(100% - 160px);
        }

        &.top {
            top: 0;
            height: 440px;
        }

        &.bottom {
            bottom: 0;
            height: 150px;
        }
    }

    i {
        color: var(--x-color-secondary);
        font-size: 12rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export function ScanPage() {
    return (
        <Wrapper>
            <div>
                <UiIconMaterial>qr_code_scanner</UiIconMaterial>
                {/*<div className="ov top"></div>*/}
                {/*<div className="ov right"></div>*/}
                {/*<div className="ov bottom"></div>*/}
                {/*<div className="ov left"></div>*/}
                {/**/}
                {/*<div className="image-container">*/}
                {/*    <UiImage src={imageScan} />*/}
                {/*</div>*/}
            </div>
        </Wrapper>
    );
}

ScanPage.route = '/scan';
